<div class="flex gap-0 mb-4 mr-5 ml-0">
    <p class="font-semibold text[#424242]  dark:text-[#FFFFFF] dark:bg-blacks cursor-pointer">Assign Targets</p>
</div>

<div class="w-full min-h-screen py-7 bg-tileLight dark:bg-[#363636] shadow-lg rounded-lg">
    <div class="px-10">
        <div class="flex flex-row justify-between items-center">
            <div class="flex flex-row gap-4">
                <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectPackingLIne}" (click)="selectPackingLIne()">
                    <i *ngIf="isSelectPackingLIne" class="fa-solid fa-check"></i>
                    <p>Packing Line</p>
                </div>

                <div class="flex flex-row items-center gap-2 border-[2px] rounded-2xl px-4 py-2 cursor-pointer dark:text-textDark dark:bg-[#292929]"
                    [ngClass]="{'text-[#415CFF] border-[#415CFF]': isSelectPositioning}" (click)="selectPositioning()">
                    <i *ngIf="isSelectPositioning" class="fa-solid fa-check"></i>
                    <p>Positioning</p>
                </div>
            </div>

        </div>
    </div>

    <hr class="my-4 border-[1px] border-[#7F7F7F]" />
    <div class="px-10">
        <app-dch-packing-line *ngIf="isSelectPackingLIne" />

        <app-dcm-positioning *ngIf="isSelectPositioning" />


    </div>

</div>